import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { translationKey } from '@change-corgi/core/i18n';
import { Translate, TypedTranslate } from '@change-corgi/core-react/i18n';

import { SectionIntro } from '#src/app/pages/about/impact/shared/components';

import { PILLARS } from './consts';

export const PoweredByPeople: React.FC<EmptyProps> = () => {
	return (
		<section className="container pb-16 md:pb-32" data-qa="powered-by-people-section">
			<div className="grid gap-5 md:grid-cols-[0.9fr_1.1fr] md:gap-18">
				<SectionIntro
					eyebrow={translationKey('corgi.impact_page.powered_by_people.eyebrow')}
					heading={translationKey('corgi.impact_page.powered_by_people.heading')}
					align="start"
				/>
				<div className="flex flex-col gap-7">
					<Text as="p" variant="body" size="large" className="text-typography-weak">
						<Translate value="corgi.impact_page.powered_by_people.body" />
					</Text>
					<div className="border-stroke-weaker grid grid-cols-1 gap-5 border-t pt-7 md:grid-cols-3 md:gap-7">
						{PILLARS.map(({ id, title, description }) => (
							<div key={id} className="flex flex-col gap-2">
								<Text as="h3" variant="heading" size="xx-small">
									<TypedTranslate value={title} />
								</Text>
								<Text as="p" size="small" className="text-typography-weak">
									<TypedTranslate value={description} />
								</Text>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};
